import React, {useEffect, useState} from 'react'
import {Navigate} from 'react-router-dom'
import {Button, Container, Form, FormGroup, FormInput, Header, Segment} from 'semantic-ui-react'
import {useAuth} from '../context/AuthContext'
import {reportApi} from '../misc/ReportApi'
import {handleLogError, ppTypes} from '../misc/Helpers'
import ReportList from "./ReportList";
import Calendar from "react-calendar";
import moment from "moment/moment";

function ReportListPage() {

  const [reports, setReports] = useState([])
  const [pp, setPP] = useState()
  const [fromDate, setFromDate] = useState()
  const [toDate, setToDate] = useState()
  const [isReportsLoading, setIsReportsLoading] = useState(false)
  const [showCalendarFrom, setShowCalendarFrom] = useState(false);
  const [showCalendarTo, setShowCalendarTo] = useState(false);

  useEffect(() => {
    handleGetReports()
  }, [])

  const handleGetReports = async () => {
    try {
      setIsReportsLoading(true)
      const searchRequest = {
        pp: pp, from: fromDate, to: toDate
      }
      const response = await reportApi.search(searchRequest)
      setReports(response.data)
    } catch (error) {
      handleLogError(error)
    } finally {
      setIsReportsLoading()
    }
  }

  const handleReset = async () => {
    console.log('reset');
    setFromDate('');
    setPP('');
    setToDate('');
  }

  const handleDateChangeFrom = value => {
    setFromDate(moment(value).format( 'DD/MM/YYYY'))
    setShowCalendarFrom(false)
  };

  const handleDateChangeTo = value => {
    setToDate(moment(value).format( 'DD/MM/YYYY'))
    setShowCalendarTo(false)
  };

  const handleInputChange = (e, {name, value}) => {
    if (name === 'pp') {
      setPP(value)
    }
  }

  const dateStyle = (showCalendar) => {
    return showCalendar ? {"display": "none"} : {"display": "flex"}
  }


  return (
    <Container>
      <Segment>
        <Header as='h1' textAlign='center'>Искать отчёты по параметрам</Header>
        <Form  onSubmit={handleGetReports}>
          <FormGroup widths={2}>
            <Form.Dropdown
              label='Граница'
              selection
              name='pp'
              options={ppTypes}
              value={pp}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup widths={2}>
            <FormInput style={dateStyle(showCalendarFrom)} label='С Даты' value={fromDate} onFocus={() => setShowCalendarFrom(true)}/>
            <Calendar
              className={showCalendarFrom ? "" : "hide"}
              name='fromDate'
              formatLongDate={(locale, date) => moment(date).format( 'dd/MM/yyyy')}
              onChange={handleDateChangeFrom}
              value={fromDate}
            />
            <FormInput style={dateStyle(showCalendarTo)} label='По дату' value={toDate} onFocus={() => setShowCalendarTo(true)}/>
            <Calendar
              className={showCalendarTo ? "" : "hide"}
              name='toDate'
              formatLongDate={(locale, date) => moment(date).format( 'dd/MM/yyyy')}
              onChange={handleDateChangeTo}
              value={toDate}
            />
          </FormGroup>
          <FormGroup widths={2}>
            <Button color='blue' type='submit'>Искать</Button>
            <Button color='blue' onClick={handleReset}>Сбросить</Button>
          </FormGroup>
        </Form>
      </Segment>
      <ReportList
        isReportsLoading={isReportsLoading}
        reports={reports}
      />
    </Container>
  )
}

export default ReportListPage
